import { addToSet, removeFromSet } from '../../setHelpers';
import { YesNoFlag } from '../../types';

import {
  ADD_JOB,
  ADD_JOB_SUCCESS,
  ADD_JOB_FAILURE,
  FETCH_JOBS,
  FETCH_JOBS_SUCCESS,
  FETCH_JOBS_FAILURE,
  MARK_JOB_NOTIFICATIONS_AS_SEEN,
} from './types';

import initialState from './initialState';

const jimReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_JOB:
      return {
        ...state,
        adding: true,
        jobTypesBeingAdded: addToSet(state.jobTypesBeingAdded, action.jobType),
      };
    case ADD_JOB_SUCCESS:
      return {
        ...state,
        jobs: [action.job, ...state.jobs],
        adding: false,
        jobTypesBeingAdded: removeFromSet(state.jobTypesBeingAdded, action.job.jobType),
      };
    case ADD_JOB_FAILURE:
      return {
        ...state,
        adding: false,
        jobTypesBeingAdded: removeFromSet(state.jobTypesBeingAdded, action.jobType),
      };
    case FETCH_JOBS:
      return {
        ...state,
        fetching: true,
      };
    case FETCH_JOBS_SUCCESS:
      return {
        ...state,
        fetching: false,
        jobs: action.jobs,
        lastUpdated: Date.now(),
      };
    case FETCH_JOBS_FAILURE:
      return {
        ...state,
        fetching: false,
        lastUpdated: Date.now(),
      };
    case MARK_JOB_NOTIFICATIONS_AS_SEEN:
      return {
        ...state,
        jobs: state.jobs.map(job => ({
          ...job,
          notificationSeenFlag: action.jobIds.has(job.jobId)
            ? YesNoFlag.Y
            : job.notificationSeenFlag,
        })),
      };
    default:
      return state;
  }
};

export default jimReducer;
